import React, { Component } from 'react';
import { connect } from 'react-redux';
import { EditDeviceGroupDialog } from '../dialogs/EditDeviceGroupDialog';
import { map, mapKV, asArray } from '../utils/map';
import { editDeviceGroup } from '../redux/actions/deviceGroupActions';
import { timeStampToString } from '../utils/stringUtils';
import { extractAppsApprovedByBundles, extractAllApps, extractKioskAppOptions } from '../utils/deviceGroupUtils';

const NONE = 'NONE';

export class EditDeviceGroup extends Component {
    state = {
        name: '',
        registrationCode: '',
        nameNotUnique: false,
        registrationCodeNotUnique: false,
        saveAvaliable: false,
        selectedBundleKeys: [],
        kioskAppKey: NONE,
        organizationKey: '',
        selectedApps: {},
        hiddenApps: {},
        firstTimeUseAppKey: NONE,
        firstTimeUseFilePaths: [],
    };

    componentDidMount() {
        const { selectedKey, deviceGroups } = this.props;
        const selectedGroup = deviceGroups[selectedKey];
        let selectedBundleKeys = [];
        selectedGroup.contentBundleRefs.map((s) => selectedBundleKeys.push(s.id));
        const { kioskAppRef, organizationRef, approvedApps, hiddenAppRefs, firstTimeUseAppRef } = selectedGroup;
        const kioskAppKey = kioskAppRef ? kioskAppRef.id : NONE;
        const firstTimeUseAppKey = firstTimeUseAppRef ? firstTimeUseAppRef.id : NONE;
        const organizationKey = organizationRef.id;
        let selectedApps = {};
        let hiddenApps = {};
        if (approvedApps) approvedApps.map((appRef) => (selectedApps[appRef.id] = true));
        if (hiddenAppRefs) hiddenAppRefs.map((appRef) => (hiddenApps[appRef.id] = true));
        this.setState({
            ...selectedGroup,
            selectedBundleKeys,
            kioskAppKey,
            firstTimeUseAppKey,
            saveAvaliable: true,
            organizationKey,
            selectedApps,
            hiddenApps,
        });
    }

    onNameChange = (name) => this.setState({ name }, this.checkSaveAvaliable);

    onRegistrationCodeChange = (registrationCode) => this.setState({ registrationCode }, this.checkSaveAvaliable);

    onBundlesChange = (selectedBundleKeys) => this.setState({ selectedBundleKeys }, this.checkSaveAvaliable);

    onKioskAppChange = (kioskAppKey) => this.setState({ kioskAppKey });

    onOrganizationChange = (organizationKey) => this.setState({ organizationKey }, this.checkSaveAvaliable);

    onFTUFilePathsChange = (firstTimeUseFilePaths) => this.setState({ firstTimeUseFilePaths }, this.checkSaveAvaliable);

    onFirstTimeUseAppChange = (firstTimeUseAppKey) => {
        this.setState({ firstTimeUseAppKey });
    };

    checkSaveAvaliable = () => {
        const { name, registrationCode, selectedBundleKeys, organizationKey } = this.state;
        const { deviceGroups, selectedKey } = this.props;
        let nameNotUnique = false;
        let registrationCodeNotUnique = false;
        mapKV(deviceGroups, (k, v) => {
            if (k === selectedKey) return;
            // if (name.trim() === v.name) nameNotUnique = true; Luke Disabled Name Unique Check. This can be deleted throughout code.
            if (registrationCode === v.registrationCode) registrationCodeNotUnique = true;
        });

        this.setState({ nameNotUnique, registrationCodeNotUnique });

        let saveAvaliable = true;
        if (nameNotUnique || name === '' || registrationCodeNotUnique || registrationCode === '' || organizationKey === '') saveAvaliable = false;
        this.setState({ saveAvaliable });
    };

    onSave = () => {
        const { name, registrationCode, selectedBundleKeys, kioskAppKey, organizationKey, selectedApps, hiddenApps, firstTimeUseFilePaths, firstTimeUseAppKey } = this.state;
        const { editDeviceGroup, onClose, selectedKey } = this.props;
        const approvedAppsKeys = [];
        asArray(selectedApps).map(({ key }) => approvedAppsKeys.push(key));

        const hiddenAppKeys = [];
        asArray(hiddenApps).map(({ key }) => hiddenAppKeys.push(key));

        editDeviceGroup({
            key: selectedKey,
            name,
            registrationCode,
            selectedBundleKeys,
            kioskAppKey,
            organizationKey,
            approvedAppsKeys,
            hiddenAppKeys,
            firstTimeUseFilePaths,
            firstTimeUseAppKey,
        });
        onClose();
    };

    onAppSelect = ({ key, value }) => {
        let { selectedApps, hiddenApps } = this.state;
        if (value) {
            selectedApps[key] = value;
        } else {
            delete selectedApps[key];
            delete hiddenApps[key];
        }
        this.setState({ selectedApps, hiddenApps });
    };

    onAppHide = ({ key, value }) => {
        let { hiddenApps } = this.state;
        if (value) {
            hiddenApps[key] = value;
        } else {
            delete hiddenApps[key];
        }
        this.setState({ hiddenApps });
    };

    render() {
        const { onClose, contentBundles, apps, devices, selectedKey, deviceGroups } = this.props;
        const {
            selectedBundleKeys,
            name,
            registrationCode,
            nameNotUnique,
            registrationCodeNotUnique,
            saveAvaliable,
            kioskAppKey,
            organizationKey,
            selectedApps,
            hiddenApps,
            firstTimeUseFilePaths,
            firstTimeUseAppKey,
        } = this.state;
        let allAppBundles = [];
        mapKV(contentBundles, (key, { name }) => allAppBundles.push({ value: key, label: name }));

        const appsApprovedByBundles = extractAppsApprovedByBundles({
            contentBundles,
            selectedBundleKeys,
        });

        const allApps = extractAllApps(apps);

        const kioskAppOptions = extractKioskAppOptions({
            appsApprovedByBundles,
            apps,
            selectedApps,
        });

        let groupDevices = [];
        map(devices, ({ deviceGroupRef, name, serial, lastUpdated }) => {
            if (deviceGroupRef.id === selectedKey) {
                groupDevices.push([name, serial, lastUpdated ? timeStampToString(lastUpdated) : 'N/A']);
            }
        });

        return (
            <EditDeviceGroupDialog
                onClose={onClose}
                deviceGroup={deviceGroups[selectedKey]}
                allAppBundles={allAppBundles}
                selectedBundleKeys={selectedBundleKeys}
                onBundleSelect={this.onBundlesChange}
                allApps={allApps}
                selectedApps={selectedApps}
                appsApprovedByBundles={appsApprovedByBundles}
                onAppSelect={this.onAppSelect}
                name={name}
                onNameChange={this.onNameChange}
                registrationCode={registrationCode}
                onRegistrationCodeChange={this.onRegistrationCodeChange}
                nameNotUnique={nameNotUnique}
                registrationCodeNotUnique={registrationCodeNotUnique}
                saveAvaliable={saveAvaliable}
                onSave={this.onSave}
                devices={groupDevices}
                apps={apps}
                kioskAppKey={kioskAppKey}
                kioskAppOptions={kioskAppOptions}
                onKioskAppChange={this.onKioskAppChange}
                organizationKey={organizationKey}
                onOrganizationChange={this.onOrganizationChange}
                onAppHide={this.onAppHide}
                hiddenApps={hiddenApps}
                onFTUFilePathsChange={this.onFTUFilePathsChange}
                firstTimeUseFilePaths={firstTimeUseFilePaths}
                onFirstTimeUseAppChange={this.onFirstTimeUseAppChange}
                firstTimeUseAppKey={firstTimeUseAppKey}
                deviceSystemVesions={this.props.deviceSystemVesions}
                localeLanguageTag={this}
                localeLanguageTag={this}
                timeZoneSetting
                targetDeviceSystemVersions
            />
        );
    }
}

const mapStateToProps = (state) => ({
    contentBundles: state.data.contentBundles,
    apps: state.data.apps,
    deviceGroups: state.data.deviceGroups,
    devices: state.data.devices,
    deviceSystemVesions: state.data.deviceSystemVesions,
});

const mapDispatchToProps = { editDeviceGroup };

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditDeviceGroup);
